import React from 'react';
import { useIntl } from 'react-intl';
import type { AppStatus } from '../types';

interface StatusBarProps {
  status: AppStatus;
}

const StatusBar: React.FC<StatusBarProps> = ({ status }) => {
  const intl = useIntl();
  const healthLabel = status.health
    ? intl.formatMessage({
        id: 'statusBar.health.healthy',
        defaultMessage: 'Healthy',
      })
    : intl.formatMessage({
        id: 'statusBar.health.unhealthy',
        defaultMessage: 'Unhealthy',
      });
  const readyLabel = status.ready
    ? intl.formatMessage({
        id: 'statusBar.ready.ready',
        defaultMessage: 'Ready',
      })
    : intl.formatMessage({
        id: 'statusBar.ready.notReady',
        defaultMessage: 'Not Ready',
      });

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
      }}
      title={intl.formatMessage(
        {
          id: 'statusBar.healthTitle',
          defaultMessage: 'Health: {health} | Ready: {ready}',
        },
        { health: healthLabel, ready: readyLabel }
      )}
    >
      <span
        style={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          background: status.health ? '#0b7a3a' : '#a05a00',
          flexShrink: 0,
        }}
        title={healthLabel}
      />
      <span
        style={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          background: status.ready ? '#0b7a3a' : '#a05a00',
          flexShrink: 0,
        }}
        title={readyLabel}
      />
    </div>
  );
};

export default StatusBar;
